import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "..";
import { ShopActions } from "../actions";
import { ShopService } from "../services";

const useShops = () => {
  const dispatch = useDispatch();
  const {
    martWebsiteAuth: { isLoggedIn, user },
    shops: { shops, isLoaded },
  } = useAppSelector((state) => state);
  const [loading, setLoading] = useState<boolean>(false);
  const findAll = async () => {
    try {
      setLoading(true);
      const response = await ShopService.findAll();
      if (response.response) {
        dispatch(ShopActions.load(response.response));
      }
    } catch (err: any) {
      console.log(err);
      // if (err && err.response && err.response.data) {
      //   setError(err.response.data);
      // } else {
      //   setError({
      //     message: err.message,
      //   });
      // }
    } finally {
      setLoading(false);
    }
  };
  return {
    loading,
    isLoggedIn,
    user,
    isLoaded,
    shops,
    findAll,
  };
};

export default useShops;
